import { render } from "./FetchTable.vue?vue&type=template&id=3b94b502&scoped=true"
import script from "./FetchTable.vue?vue&type=script&lang=js"
export * from "./FetchTable.vue?vue&type=script&lang=js"

import "./FetchTable.vue?vue&type=style&index=0&id=3b94b502&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b94b502"]])

export default __exports__